var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconReplaceDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.13 30.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #A3A0FB;\n      }\n\n      .cls-3 {\n        fill: #A3A0FB;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 30.13,
    height: 30.03
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Composant_116_1",
    "data-name": "Composant 116 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4488",
    "data-name": "Groupe 4488"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1985",
    "data-name": "Rectangle 1985",
    className: "cls-3",
    x: 18.87,
    y: 21.27,
    width: 11.26,
    height: 8.76,
    rx: 0.94,
    ry: 0.94
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15589",
    "data-name": "Trac\\xE9 15589",
    className: "cls-2",
    d: "M26.31,12.51h3.07c.62,0,.94.56.56.88l-5,5.19c-.26.19-.61.19-.88,0l-5-5.19c-.38-.38-.06-.88.56-.88h2.94c-.2-3.35-2.86-6.03-6.2-6.26v-3.76c5.43-.07,9.88,4.28,9.95,9.71,0,.1,0,.2,0,.3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1986",
    "data-name": "Rectangle 1986",
    className: "cls-2",
    y: 0,
    width: 11.26,
    height: 8.76,
    rx: 0.94,
    ry: 0.94
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplaceDisabled);
export default __webpack_public_path__ + "static/media/Icon-replace-disabled.95a6e3cb87c00f0e0a46339f17515f10.svg";
export { ForwardRef as ReactComponent };